export default __webpack_public_path__ + "static/media/1.86a501f0.png";